module.exports = {
  "id": "92067ed9-0a60-4ba1-83a5-fa74c3dcdc14",
  "gtmIds": [
    "GTM-KP73V64D",
    "GTM-T2TNT6",
    "GTM-KKS578WK"
  ],
  "startTracking": "after_accepting_cookies",
  "hasInAppVersion": false,
  "group": "moreys",
  "language": "en-US",
  "defaultDateFormat": "WEEKDAY_SHORT_MONTH_SHORT_DAY_INTL",
  "defaultNumberFormat": null,
  "pricingSavingsAmountPrecision": "exact",
  "checkoutTaxesFeesBreakdownDisplayMode": "modal",
  "languages": [
    "en-US"
  ],
  "website": "https://www.bluepalmsresort.com",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}